import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

function Sparkline({ data = [], color = '#0F3D5C' }) {
  if (!data.length) return null;
  const w = 80, h = 28;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const pts = data.map((v, i) => {
    const x = (i / (data.length - 1)) * w;
    const y = h - ((v - min) / range) * (h - 4) - 2;
    return `${x.toFixed(1)} ${y.toFixed(1)}`;
  });
  const polyline = pts.join(' L ');
  const area = `M ${pts[0]} L ${polyline} L ${w} ${h} L 0 ${h} Z`;

  return (
    <svg width={w} height={h}>
      <path d={area} fill={color} opacity="0.12" />
      <polyline
        points={pts.join(', ')}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function KpiCard({
  label,
  value,
  trend,
  trendLabel,
  sub,
  icon: Icon,
  sparkline,
  sparklineColor = '#0F3D5C',
  className = '',
}) {
  const trendPositive = trend === 'up';
  const trendNegative = trend === 'down';

  return (
    <div className={`bg-white border border-slate-200 rounded-xl p-4 relative overflow-hidden ${className}`}>
      {/* Header */}
      {(Icon || label) && (
        <div className="flex items-center gap-2 text-[11.5px] text-slate-500 font-medium mb-1">
          {Icon && <Icon size={14} strokeWidth={1.75} />}
          {label}
        </div>
      )}

      {/* Value */}
      <div className="text-2xl font-semibold tracking-tight tabular-nums text-slate-900">
        {value}
      </div>

      {/* Trend / Sub */}
      {(trendLabel || sub) && (
        <div
          className={`flex items-center gap-1 text-[11.5px] mt-0.5 ${
            trendPositive
              ? 'text-emerald-600'
              : trendNegative
              ? 'text-rose-600'
              : 'text-slate-500'
          }`}
        >
          {trendPositive && <ArrowUp size={12} strokeWidth={2} />}
          {trendNegative && <ArrowDown size={12} strokeWidth={2} />}
          {trendLabel || sub}
        </div>
      )}

      {/* Sparkline */}
      {sparkline && (
        <div className="absolute right-3 bottom-3 pointer-events-none">
          <Sparkline data={sparkline} color={sparklineColor} />
        </div>
      )}
    </div>
  );
}

export default KpiCard;
